// Shared styles for help documentation rendering across plugin components
export const HELP_DOC_STYLES = `
  /* Heading styles */
  .prose h1 {
    font-size: 2em !important;
    font-weight: bold !important;
    margin: 0.67em 0 !important;
    line-height: 1.2 !important;
    display: block !important;
  }

  .prose h2 {
    font-size: 1.5em !important;
    font-weight: bold !important;
    margin: 0.75em 0 !important;
    line-height: 1.3 !important;
    display: block !important;
  }

  .prose h3 {
    font-size: 1.17em !important;
    font-weight: bold !important;
    margin: 0.83em 0 !important;
    line-height: 1.4 !important;
    display: block !important;
  }

  .prose h4 {
    font-size: 1em !important;
    font-weight: bold !important;
    margin: 1.12em 0 !important;
    line-height: 1.4 !important;
    display: block !important;
  }

  .prose h5 {
    font-size: 0.83em !important;
    font-weight: bold !important;
    margin: 1.5em 0 !important;
    line-height: 1.4 !important;
    display: block !important;
  }

  .prose h6 {
    font-size: 0.67em !important;
    font-weight: bold !important;
    margin: 1.67em 0 !important;
    line-height: 1.4 !important;
    display: block !important;
  }

  /* Blockquote styles */
  .prose blockquote {
    display: block !important;
    margin: 1em 0 !important;
    padding: 10px 20px !important;
    border-left: 4px solid var(--secondary) !important;
    background-color: var(--muted) !important;
    font-style: italic !important;
    color: var(--muted-foreground) !important;
  }

  .prose blockquote p {
    margin: 0 !important;
    display: block !important;
  }

  /* Code block styles */
  .prose pre {
    display: block !important;
    font-family: monospace !important;
    background-color: var(--light-gray) !important;
    border: 1px solid var(--border) !important;
    border-radius: 4px !important;
    padding: 10px !important;
    margin: 10px 0 !important;
    overflow-x: auto !important;
    white-space: pre !important;
  }

  .prose code {
    font-family: monospace !important;
    background-color: var(--light-gray) !important;
    padding: 2px 4px !important;
    border-radius: 3px !important;
    font-size: 0.9em !important;
  }

  .prose pre code {
    background-color: transparent !important;
    padding: 0 !important;
  }

  /* Table styles */
  .prose table {
    border-collapse: collapse !important;
    width: 100% !important;
    border: 1px solid var(--border) !important;
    margin: 1em 0 !important;
  }
  
  .prose table thead tr {
    border-bottom: 1px solid var(--border) !important;
  }
  
  .prose table th,
  .prose table td {
    border: 1px solid var(--border) !important;
    padding: 0.75rem !important;
    text-align: left !important;
  }
  
  .prose table th {
    background-color: var(--muted) !important;
    font-weight: 600 !important;
  }
  
  .prose table tbody tr:nth-child(even) {
    background-color: var(--extra-light-gray) !important;
  }
`;
